import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9a3f0722"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overlay" }
const _hoisted_2 = { class: "cart-additional-category-calculator" }
const _hoisted_3 = {
  key: 0,
  class: "cart-additional-category-calculator__loader"
}
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "row g-3 g-xl-4" }
const _hoisted_6 = { class: "col text-start" }
const _hoisted_7 = { class: "col-auto" }
const _hoisted_8 = { class: "col-6" }
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = {
  key: 0,
  class: "col-8"
}
const _hoisted_11 = {
  key: 1,
  class: "col-4"
}
const _hoisted_12 = {
  key: 2,
  class: "col-12"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-danger m-0" }, " Für die Berechnung Deines Wunschtarifs benötigen wir noch Deine Straße und Hausnummer. ", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-auto" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, null, -1))
const _hoisted_19 = { class: "col-auto" }

import { EnetAPI } from '@/api';
import IoProducts from '@/api/IoProductAPI';
import BaseCalculatorUsageField from '@/components/BaseCalculator/BaseCalculatorUsageField.vue';
import BranchInterface from '@/interfaces/BranchInterface';
import CartCommodityInterface from '@/interfaces/CartCommodityInterface';
import CityInterface from '@/interfaces/CityInterface';
import ProductPriceParamsInterface from '@/interfaces/ProductPriceParamsInterface';
import StreetInterface from '@/interfaces/StreetInterface';
import InputField from '@/components/InputField.vue';
import SelectField from '@/components/SelectField.vue';
import BaseButton from '@/components/BaseButton.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';

import {
  computed,
  PropType, reactive, ref, watch,
} from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'CartAdditionalCategoryCalculator',
  props: {
  branch: {
    type: Object as PropType<BranchInterface>,
    required: true,
  },
  address: Object,
  successPage: Boolean,
},
  emits: ['cancel'],
  setup(__props, { emit: __emit }) {

library.add(faSpinner);

const props = __props;

const emit = __emit;

const store = useStore();
const router = useRouter();

const lastCartItemParams = computed<ProductPriceParamsInterface | null>(() => {
  const cartItems = Object.values(store.getters['cart/commodity'] || {}) as CartCommodityInterface[];

  if (cartItems.length) {
    return cartItems[cartItems.length - 1].product.price?.params || {} as ProductPriceParamsInterface;
  }

  return null;
});

const editAddressEnabled = ref(false);

const options = reactive({
  branch: props.branch,
  postcode: props.address?.postcode || lastCartItemParams.value?.postcode || null,
  postcodeLoaded: '',
  pricesExists: {
    for: '',
    value: {
      postcode: true,
      street: !!(props.address?.street || lastCartItemParams.value?.street),
    },
  },
  initialStreet: !!(props.address?.street || lastCartItemParams.value?.street),
  showStreetMessage: false,
  isFetching: false,
  isLoading: false,
  preselectedPostcodeSet: false,
  selectableCities: [] as CityInterface[],
  selectableStreets: [] as StreetInterface[],
  usage: props.branch.mainCategory.key === 'power' ? 1500 : 3800,
  city: props.address?.city || lastCartItemParams.value?.city,
  street: props.address?.street || lastCartItemParams.value?.street,
  houseNumber: props.address?.houseNumber || lastCartItemParams.value?.houseNumber,
  business: (props.address?.postcode || lastCartItemParams.value?.customerType) === 'business',
  oeko: !!(props.address?.bio || lastCartItemParams.value?.bio),
});

watch(() => options.pricesExists.value.street, (val) => {
  if (!options.initialStreet) {
    options.showStreetMessage = val;
    options.street = options.selectableStreets[0]?.id;
  }
});

const fetchCitiesAndStreets = ($postcode: string | number) => {
  if (`${$postcode || ''}`.trim().length === 5 && $postcode !== options.postcodeLoaded) {
    options.selectableCities = [];
    options.selectableStreets = [];

    options.postcodeLoaded = $postcode as string;
    options.isLoading = true;

    EnetAPI.getCitiesAndStreets($postcode)
      .then((data) => {
        options.selectableCities = data.cities;
        options.selectableStreets = data.streets;

        options.city = options.selectableCities[0].id;
        if (options.pricesExists.value.street) {
          options.street = options.selectableStreets[0].id;
        }
      }).finally(() => {
        options.isLoading = false;
      });
  }
};

watch(() => options.postcode, ($newPostcode) => {
  fetchCitiesAndStreets($newPostcode as string);
});

fetchCitiesAndStreets(options.postcode as string);

const getCitiesOptions = ($cities: CityInterface[]) => [...$cities].map(($c) => ({
  label: $c.name,
  value: $c.id,
}));

const streetsOptions = computed(() => [...options.selectableStreets].map(($s) => ({
  label: $s.name,
  value: $s.id,
})));

const getPriceExists = async () => {
  const params = {
    customerType: options.business ? 'business' : 'private',
    usage: options.usage,
    postcode: options.postcode,
    city: options.city,
  };
  const currentForKey = JSON.stringify(params);

  if (options.pricesExists.for !== currentForKey) {
    options.isFetching = true;

    await IoProducts.getPriceExists(params).then((pricesExist) => {
      options.pricesExists.for = currentForKey;
      options.pricesExists.value = pricesExist;
    }).finally(() => {
      options.isFetching = false;
    });
  }
};

const enableAddressEdit = () => {
  editAddressEnabled.value = true;
};

const canSubmit = computed(() => `${options.postcode || ''}`.trim().length === 5
    && options.city !== null
    && (options.pricesExists.value.street ? (
      options.street !== null && `${options.houseNumber || ''}`.trim().length >= 1
    ) : true)
    && parseInt(`${options.usage || '0'}`, 10) > 0);

const submit = async () => {
  if (!canSubmit.value) {
    return;
  }

  options.isLoading = true;

  let path = '/preisanzeige/';

  await getPriceExists();

  let params: Record<string, string> = {
    stadt: options.city as string,
  };

  if (options.pricesExists.value.street) {
    params = {
      ...params,
      strasse: options.street as string,
      hausnummer: options.houseNumber as string,
    };
  }

  if (options.oeko) {
    params.oeko = '1';
  }

  if (options.business) {
    params.gewerbe = '1';
  }

  const urlParams = new URLSearchParams(params);

  path += `${props.branch.slug}/${options.postcode}/${options.usage}/?${urlParams.toString()}`;

  if (router) {
    router.push(path);
  } else {
    window.location.href = `${window.ioappConfig.shopUrl}${path}`.replace('//preisanzeige', '/preisanzeige');
  }
};

return (_ctx: any,_cache: any) => {
  const _component_BaseSpacer = _resolveComponent("BaseSpacer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (options.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createVNode(_unref(FontAwesomeIcon), {
                icon: "fa-solid fa-spinner",
                class: "fa-pulse"
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.branch.name) + " dazubestellen ", 1),
      _createVNode(_component_BaseSpacer, { size: "r" }),
      _createElementVNode("div", _hoisted_5, [
        (!editAddressEnabled.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(`${options.street || ''} ${options.houseNumber || ''}${options.street ? ',' : ''} ${options.postcode} ${options.city}`), 1),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  class: "change-address",
                  type: "button",
                  onClick: _withModifiers(enableAddressEdit, ["prevent"])
                }, " Adresse ändern ")
              ])
            ], 64))
          : _createCommentVNode("", true),
        (editAddressEnabled.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(InputField, {
                  label: "Postleitzahl*",
                  type: "text",
                  modelValue: options.postcode,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((options.postcode) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(SelectField, {
                  label: "Deine Stadt*",
                  modelValue: options.city,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((options.city) = $event)),
                  disabled: options.selectableCities.length <= 1,
                  options: getCitiesOptions(options.selectableCities),
                  search: options.selectableCities.length > 5
                }, null, 8, ["modelValue", "disabled", "options", "search"])
              ]),
              (options.pricesExists.value.street)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(SelectField, {
                      label: "Straße*",
                      modelValue: options.street,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((options.street) = $event)),
                      options: streetsOptions.value,
                      search: ""
                    }, null, 8, ["modelValue", "options"])
                  ]))
                : _createCommentVNode("", true),
              (options.pricesExists.value.street)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(InputField, {
                      label: "Haus-Nr.*",
                      type: "text",
                      modelValue: options.houseNumber,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((options.houseNumber) = $event))
                    }, null, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (options.showStreetMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(BaseCalculatorUsageField, {
            modelValue: options.usage,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((options.usage) = $event)),
            borderless: false,
            label: "Verbrauch in kWh",
            branch: __props.branch.mainCategory.key
          }, null, 8, ["modelValue", "branch"])
        ])
      ]),
      _createVNode(_component_BaseSpacer),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createVNode(BaseButton, {
            class: "cancel",
            type: "outline",
            onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (emit('cancel')), ["prevent"]))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.successPage ? 'Nicht dazubestellen' : 'Abbrechen'), 1)
            ]),
            _: 1
          })
        ]),
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createVNode(BaseButton, {
            class: "submit",
            disabled: !canSubmit.value,
            onClick: _withModifiers(submit, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.branch.name) + "produkte anzeigen ", 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ])
  ]))
}
}

})